import { defineMessages } from "react-intl";

export const ALL_POLICIES = "All Policies";
export const VIEW_NAME_REGEX = /^[a-zA-Z0-9_ ]+$/;

export const errorMessages = defineMessages({
  NO_SPECIAL_CHAR_ALLOWED: {
    id: "2Rkfe5",
    defaultMessage: "Underscore is the only allowed special character.",
    description:
      "Error shown when a saved view name contains special characters other than underscore",
  },
  DUPLICATE_ITEM: {
    id: "KSM6Wc",
    defaultMessage:
      "A view with this name already exists. Please enter a different name.",
    description: "Error shown when a saved view name is already taken",
  },
  MIN_CHAR: {
    id: "pVptXY",
    defaultMessage: "View Name must contain at least one character",
    description: "Error shown when a saved view name is empty",
  },
});
